import "@hotwired/turbo"
import * as ActiveStorage from "@rails/activestorage"
import "../turbo_cable_stream_source"
import "../controllers"
import "../stylesheets/application.css"

ActiveStorage.start()
